// APIS for the kiosk Management slice actions to call. These will be used in the kioskManagementSlice.js async thunks.

import axios from 'axios';

const KIOSK_ACCESS_LIST_API = '/api/dash/kioskAccessList';
const GRANT_KIOSK_ACCESS_API = '/api/dash/grantKioskAccess';
const REVOKE_KIOSK_ACCESS_API = '/api/dash/kioskAccess';

// Get list of workers with kiosk access to a given jobsite.
// Expects a valid JWT token and the jobsiteId whose kiosk access list is requested.
const getKioskAccessList = async (jobsiteId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            jobsiteId,
        },
    };

    console.log('Requesting kiosk access list for jobsiteId:', jobsiteId);
    const response = await axios.get(KIOSK_ACCESS_LIST_API, config);
   
    return response.data; // { workers: [...] }
};









// Grant kiosk access for a specific worker on a specific jobsite.
const grantKioskAccess = async (jobsiteId, workerId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const body = { jobsiteId, workerId };
    const response = await axios.post(GRANT_KIOSK_ACCESS_API, body, config);
    return response.data; // { message, workerName, worker }
};

// Revoke kiosk access for a specific worker on a specific jobsite.
const revokeKioskAccess = async (jobsiteId, workerId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const url = `${REVOKE_KIOSK_ACCESS_API}/${jobsiteId}/${workerId}`;
    const response = await axios.delete(url, config);
    return response.data; // { message, workerId, jobsiteId }
};

const kioskManagementService = {
    getKioskAccessList,
    grantKioskAccess,
    revokeKioskAccess,
};

export default kioskManagementService;



